<nz-drawer
  [nzWidth]="'80%'"
  [nzClosable]="true"
  [nzVisible]="visible"
  nzPlacement="right"
  nzTitle="Vehicle Dashboard"
  (nzOnClose)="visible = false"
  class="dashbSlider"
>
  @if (selectedVehicle) {
  <app-vehicle-slider [vechile]="selectedVehicle"></app-vehicle-slider>
  }
</nz-drawer>
<div class="row hdrBar">
  <div class="col-lg-12 col-md-12 mg-a">
    <h1>Vehicle wise Billing</h1>
  </div>
</div>
<div class="row">
  <div class="col-lg-3 col-md-3 mg-a">
    <p class="slctlbl">ULB</p>
    <nz-select
      class="slctBx"
      nzShowSearch
      [(ngModel)]="selectedtenant"
      nzPlaceHolder="Select ULB"
      (ngModelChange)="ontntSelect($event)"
      [ngModelOptions]="{ standalone: true }"
    >
      @if (!showVndr) {
      <nz-option [nzLabel]="'All'" [nzValue]="0"></nz-option>
      } @for (t of tntLst; track t) {
      <nz-option [nzValue]="t.tnt_id" [nzLabel]="t.tnt_nm"></nz-option>
      }
    </nz-select>
  </div>
  <div class="col-lg-3 col-md-3 mg-a">
    <p class="slctlbl">Vehicle Vendor</p>
    <nz-select
      class="slctBx"
      nzShowSearch
      [(ngModel)]="selectedvndr"
      (ngModelChange)="onvndrSelect($event)"
      nzPlaceHolder="Select Vehicle Vendor"
      [ngModelOptions]="{ standalone: true }"
    >
      @for (v of vendorList; track v) {
      <nz-option [nzValue]="v.vndr_id" [nzLabel]="v.vndr_nm"></nz-option>
      }
    </nz-select>
  </div>
  <div class="col-lg-3 col-md-3 mg-a">
    <p class="slctlbl">Year</p>
    <nz-select
      class="slctBx"
      [(ngModel)]="selectedYear"
      (ngModelChange)="onSelectMnthYr()"
      [ngModelOptions]="{ standalone: true }"
    >
      @for (y of years; track y) {
      <nz-option [nzValue]="y" nzLabel="{{ y }}"></nz-option>
      }
    </nz-select>
  </div>

  <div class="col-lg-3 col-md-3 mg-a">
    <p class="slctlbl">Month</p>
    <nz-select
      class="slctBx"
      [(ngModel)]="selectedmonth"
      (ngModelChange)="onSelectMnthYr()"
      [ngModelOptions]="{ standalone: true }"
    >
      @for (m of months; track m) {
      <nz-option [nzValue]="m.id" nzLabel="{{ m.name }}"></nz-option>
      }
    </nz-select>
  </div>
</div>
<div class="main">
  @for (cnts of cardSummary; track cnts) {
  <div class="row">
    <ul class="cards">
      <li class="cards_item">
        <div
          class="card_g"
          style="background: linear-gradient(135deg, #49948a 0%, #137986 100%)"
        >
          <div class="card_content">
            <div class="row">
              <h1 class="crdHdr">Total Vehicles</h1>
            </div>
            <div class="row crdHdr_sb">
              <!-- <div class="col-lg-6 col-md-6">
                <h1>
                  <i nz-icon nzType="car" nzTheme="outline"></i>
                </h1>
              </div>-->
              <div class="col-lg-12 col-md-12">
                <h1 class="card_sub_title">{{ cnts.tot_veh }}</h1>
              </div>
            </div>
          </div>
          <div class="card_g_ftr1">
            <h1 class="card_sub_title textSmall" style="color: white">(A)</h1>
          </div>
        </div>
      </li>
      <li class="cards_item">
        <div
          class="card_g"
          style="background: linear-gradient(135deg, #65548a 0%, #352e88 100%)"
        >
          <div class="card_content">
            <div class="row">
              <h1 class="crdHdr">Total Work Days</h1>
            </div>
            <div class="row crdHdr_sb">
              <!-- <div class="col-lg-6 col-md-6">
              <h1>
                <i nz-icon nzType="calendar" nzTheme="outline"></i>
              </h1>
            </div> -->
              <div class="col-lg-12 col-md-12">
                <h1 class="card_sub_title"></h1>
              </div>
            </div>
            <div class="row crdHdr_sb_sm">
              <div class="col-lg-6 col-md-6">
                <h1 class="textSmall">
                  {{ mnthnm }}
                </h1>
              </div>
              <div class="col-lg-6 col-md-6">
                <h1 class="card_sub_title">{{ daysInMonth }}</h1>
              </div>
            </div>
          </div>
          <div class="card_g_ftr2">
            <h1 class="card_sub_title textSmall" style="color: white">(B)</h1>
          </div>
        </div>
      </li>
      <li class="cards_item">
        <div
          class="card_g"
          style="background: linear-gradient(135deg, #429749 0%, #62680b 100%)"
        >
          <div class="card_content">
            <div class="row">
              <h1 class="crdHdr">Expected Vehicle Work Days</h1>
            </div>
            <div class="row crdHdr_sb">
              <!-- <div class="col-lg-6 col-md-6">
            <h1>
              <i nz-icon nzType="carry-out" nzTheme="outline"></i>
            </h1>
          </div> -->
              <div class="col-lg-12 col-md-12">
                <h1 class="card_sub_title">{{ cnts.exptd_wrkng_dy_ct }}</h1>
              </div>
            </div>
          </div>
          <div class="card_g_ftr3">
            <h1 class="card_sub_title textSmall" style="color: white">
              (C = A * B)
            </h1>
          </div>
        </div>
      </li>
      <li class="cards_item">
        <div
          class="card_g"
          style="background: linear-gradient(135deg, #6e3f74 0%, #8a1a82 100%)"
        >
          <div class="card_content">
            <div class="row">
              <h1 class="crdHdr">Operational Vehicle Work Days</h1>
            </div>
            <div class="row crdHdr_sb">
              <!-- <div class="col-lg-6 col-md-6">
          <h1>
            <i nz-icon nzType="calendar" nzTheme="outline"></i>
          </h1>
        </div> -->
              <div class="col-lg-12 col-md-12">
                <h1 class="card_sub_title">{{ cnts.oprtnl_wrkng_dy_ct }}</h1>
              </div>
            </div>
          </div>
          <div class="card_g_ftr4">
            <h1 class="card_sub_title textSmall" style="color: white">(D)</h1>
          </div>
        </div>
      </li>
      <li class="cards_item">
        <div
          class="card_g"
          style="background: linear-gradient(135deg, #404185 0%, #3b2a64 100%)"
        >
          <div class="card_content">
            <div class="row">
              <h1 class="crdHdr">Non Operational Vehicle Work Days</h1>
            </div>
            <div class="row crdHdr_sb">
              <!-- <div class="col-lg-6 col-md-6">
        <h1>
          <i nz-icon nzType="node-index" nzTheme="outline"></i>
        </h1>
      </div> -->
              <div class="col-lg-12 col-md-12">
                <h1 class="card_sub_title">{{ cnts.nt_oprtnl_wrkng_dy_ct }}</h1>
              </div>
            </div>
          </div>
          <div class="card_g_ftr5">
            <h1 class="card_sub_title textSmall" style="color: white">(E)</h1>
          </div>
        </div>
      </li>
    </ul>
  </div>
  }
  <div class="main">
    <!-- <div class="row" style="margin-bottom: 10px;margin-top: 10px;">
  <div class="col-lg-12 col-md-12 col-sm-12">
    <nz-card nzTitle="Vehicle Wise Billing For {{mnthnm}} - {{selectedYear}}" class="tablecard">
      <div class="row gridTop  verScroll" style="height: 100vh;" id="target">
        <div style="width:100%;margin-right: 2px;"> -->
    <div class="row bg-wp">
      <h1>Vehicle Wise Billing For {{ mnthnm }} - {{ selectedYear }}</h1>
      <div class="ds-card grid tbl">
        <app-data-grid
          [allowedPageSizes]="[10, 20, 30, 50]"
          [totalItems]="gridTotals0"
          id="gridContainer"
          style="width: 100%"
          [dataSource]="vehcleTble"
          [legacyColumns]="columnDefs"
          [searchPanel]="true"
          [filterRow]="true"
          [filterPanel]="false"
          [groupPanel]="true"
          [columnChooser]="true"
          [allowExport]="true"
          exportFileName="vehicle"
          [pageSize]="10"
          [rowAlternationEnabled]="true"
          [showBorders]="true"
          [wordWrapEnabled]="true"
        >
          <app-grid-column
            [showInColumnChooser]="false"
            [visible]="true"
            type="buttons"
            [width]="100"
            caption="View"
            cellTemplate="editTemplate"
          ></app-grid-column>
          <ng-template appGridCell="editTemplate" let-data="cell"
            ><div>
              <div class="tblEdtBtn" (click)="gotovehcleDashboard(data)">
                <i nz-icon nzType="car" nzTheme="outline"></i>
              </div></div
          ></ng-template>
          <!--
                <app-grid-column [showInColumnChooser]="false" [visible]="true" type="buttons" [width]="100"
                caption="Edit" cellTemplate="editTemplate2"></app-grid-column>
                <ng-template appGridCell="editTemplate2" let-data="cell"><div>
                  <div class="tblEdtBtn" (click)="gotovehclesPage(data)"><i nz-icon nzType="edit" nzTheme="outline"></i></div>
                </div></ng-template>
                -->
        </app-data-grid>
        <!-- </div>
          </div>
        </nz-card> -->
      </div>
    </div>
  </div>
</div>
